<template>
  <a-drawer
    :maskClosable="false"
    width="80%"
    title="详情"
    placement="right"
    :closable="true"
    :visible="visible"
    @close="onClose"
  >
    <div>
      <a-descriptions :column="4" title="基本信息" class="full-width-descriptions">
        <a-descriptions-item label="订单编号"> {{ form.orderNo ? form.orderNo : '--' }}</a-descriptions-item>
        <a-descriptions-item label="用户手机号">{{ form.userPhone ? form.userPhone : '--' }}</a-descriptions-item>
        <a-descriptions-item label="店铺名称"> {{ form.shopName ? form.shopName : '--' }} </a-descriptions-item>
        <a-descriptions-item label="店铺联系电话"> {{ form.shopPhone ? form.shopPhone : '--' }}</a-descriptions-item>
        <a-descriptions-item label="收件人"> {{ form.receiverName ? form.receiverName : '--' }}</a-descriptions-item>
        <a-descriptions-item label="收件人电话">
          {{ form.receiverMobile ? form.receiverMobile : '--' }}</a-descriptions-item
        >
        <a-descriptions-item label="收件人地址">
          {{ form.receiverAddress ? form.receiverAddress : '--' }}</a-descriptions-item
        >
        <a-descriptions-item label="商品总数"> {{ form.productNums ? form.productNums : '--' }}</a-descriptions-item>
        <a-descriptions-item label="优惠总额"> {{ form.reduceAmount ? form.reduceAmount : '--' }}</a-descriptions-item>
        <a-descriptions-item label="总值"> {{ form.total ? form.total : '--' }}</a-descriptions-item>
        <a-descriptions-item label="实际总值"> {{ form.actualTotal ? form.actualTotal : '--' }}</a-descriptions-item>
        <a-descriptions-item label="付款时间"> {{ form.payTime ? form.payTime : '--' }}</a-descriptions-item>
        <a-descriptions-item label="订单状态">
          {{
            form.status == 1
              ? '待付款 '
              : form.status == 2
              ? '待审核'
              : form.status == 3
              ? '待发货'
              : form.status == 4
              ? '待收货'
              : form.status == 6
              ? '成功'
              : '失败'
          }}</a-descriptions-item
        >
        <a-descriptions-item label="支付方式">
          {{
            form.payType == 0
              ? '线下支付'
              : form.payType == 1
              ? '支付宝'
              : form.payType == 2
              ? '微信'
              : form.payType == 3
              ? '余额支付'
              : form.payType == 4
              ? '积分支付'
              : form.payType == 5
              ? '银行卡支付'
              : '第三方支付'
          }}</a-descriptions-item
        >
        <a-descriptions-item label="订单关闭原因" v-if="form.closeType">
          {{
            form.closeType == 1
              ? '超时未支付'
              : form.closeType == 2
              ? '退款关闭'
              : form.closeType == 4
              ? '买家取消'
              : form.closeType == 15
              ? '已通过货到付款交易'
              : '--'
          }}</a-descriptions-item
        >
        <a-descriptions-item label="是否已经支付"> {{ form.isPayed ? '是' : '否' }}</a-descriptions-item>
        <!-- <a-descriptions-item label="订单类型">
          {{ form.orderType == 1 ? '团购订单' : form.orderType == 2 ? '秒杀订单' : '积分订单' }}</a-descriptions-item
        > -->
        <!-- <a-descriptions-item label="预售发货时间"> {{ form.preSaleTime }}</a-descriptions-item> -->
        <!-- <a-descriptions-item label="取消时间"> {{ form.cancelTime }}</a-descriptions-item> -->
        <a-descriptions-item label="完成时间"> {{ form.finallyTime ? form.finallyTime : '--' }}</a-descriptions-item>
        <a-descriptions-item label="配送类型">
          {{
            form.dvyType == 1 ? '物流' : form.dvyType == 2 ? '自提' : form.dvyType == 3 ? '无需快递' : '无需快递'
          }}</a-descriptions-item
        >
        <a-descriptions-item label="物流单号" v-if="form.dvyType == 1">
          {{ form.dvyFlowId ? form.dvyFlowId : '--' }}</a-descriptions-item
        >
        <a-descriptions-item label="订单运费" v-if="form.dvyType == 1">
          {{ form.freightAmount ? form.freightAmount : '--' }}</a-descriptions-item
        >
        <a-descriptions-item label="发货时间"> {{ form.dvyTime ? form.dvyTime : '--' }}</a-descriptions-item>
        <a-descriptions-item label="取消时间"> {{ form.cancelTime ? form.cancelTime : '--' }}</a-descriptions-item>
        <!-- <a-descriptions-item label="订单退款状态">
          {{
            form.refundStatus == 1
              ? '申请退款'
              : form.refundStatus == 2
              ? '退款成功'
              : form.refundStatus == 3
              ? '部分退款成功 '
              : '退款失败'
          }}</a-descriptions-item
        > -->
        <a-descriptions-item label="备注"> {{ form.remark ? form.remark : '--' }}</a-descriptions-item>
        <a-descriptions-item label="买家备注"> {{ form.remarks ? form.remarks : '--' }}</a-descriptions-item>
        <a-descriptions-item label="卖家备注"> {{ form.shopRemarks ? form.shopRemarks : '--' }}</a-descriptions-item>
        <a-descriptions-item label="创建时间"> {{ form.createTime ? form.createTime : '--' }}</a-descriptions-item>
      </a-descriptions>
      <a-descriptions :column="4" title="订单商品" class="full-width-descriptions"> </a-descriptions>
      <a-table :columns="columns" :data-source="form.orderItemList">
        <div slot="pic" slot-scope="text, record">
          <div v-viewer>
            <img
              :src="$url + record.pic"
              alt=""
              style="width: 50px; height: 50px"
              @error="
                (e) => {
                  e.target.src = errorImage
                }
              "
            />
          </div>
        </div>
      </a-table>
      <a-descriptions :column="4" title="支付凭证 	" class="full-width-descriptions"> </a-descriptions>
      <a-table :columns="columnInfo" :data-source="form.orderVoucherInfo">
        <!-- <div slot="pic" slot-scope="text, record">
          <div v-viewer>
            <img
              :src="$url + record.pic"
              alt=""
              style="width: 50px; height: 50px"
              @error="
                (e) => {
                  e.target.src = errorImage
                }
              "
            />
          </div>
        </div>  -->
        <div slot="status" slot-scope="text, record">
          {{ record.status == 0 ? '待审核' : record.status == 1 ? '审核通过' : '审核失败' }}
        </div>
      </a-table>
    </div>
  </a-drawer>
</template>
<script>
import { getObj } from '@/api/declaration/declarationOrder'
import { tableMixin } from '@/store/table-mixin'
export default {
  mixins: [tableMixin],
  name: 'Post',
  data() {
    return {
      visible: false,
      form: {},
      errorImage: require('/src/assets/images/defaultImg.png'),
      columns: [
        {
          title: '商品名称',
          dataIndex: 'prodName',
          width: 150,
          align: 'center',
        },
        {
          title: '商品图片',
          dataIndex: 'pic',
          scopedSlots: { customRender: 'pic' },
          width: 150,
          align: 'center',
        },
        {
          title: '价格',
          dataIndex: 'price',
          align: 'center',
        },
        {
          title: '个数',
          dataIndex: 'prodCount',
          align: 'center',
        },
        {
          title: '总金额',
          dataIndex: 'productTotalAmount',
          align: 'center',
        },
        {
          title: 'sku名称',
          dataIndex: 'skuName',
          align: 'center',
        },
        {
          title: '排序号',
          dataIndex: 'sort',
          align: 'center',
        },
      ],
      columnInfo: [
        {
          title: '审核人员	',
          dataIndex: 'reviewerUser',
          width: 150,
          align: 'center',
        },
        {
          title: '回复内容	',
          dataIndex: 'rreviewerEply',
          //   scopedSlots: { customRender: 'rreviewerEply' },
          width: 150,
          align: 'center',
        },
        {
          title: '状态	',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          width: 150,
          align: 'center',
        },
        {
          title: '打款凭证		',
          dataIndex: 'voucherFile',
          align: 'center',
        },
        {
          title: '创建时间		',
          dataIndex: 'createTime',
          align: 'center',
        },
        {
          title: '审核时间			',
          dataIndex: 'reviewerTime',
          align: 'center',
        },
      ],
      showPrint: false,
      errorImage: require('/src/assets/images/defaultImg.png'),
      active: 1,
      placeholderImage: '~@/assets/images/defaultImg.png',
      default: 'this.src="' + require('@/assets/images/defaultImg.png') + '"',
    }
  },
  filters: {},
  created() {
    this.type = 1
  },
  computed: {
    hasPermission() {
      return (permission) => {
        if (this.$store.state.user.userTentant.type === 0) {
          return true
        } else {
          return this.$store.state.user.permissions.includes(permission)
        }
        // return true
      }
    },
  },
  watch: {},
  methods: {
    handleLook(e) {
      window.open(e)
    },
    init(e, index) {
      this.isBack = false
      getObj(e.orderId).then((res) => {
        this.form = res.data

        this.dataForm = e
        // this.active = index
        this.visible = true
      })
    },
    convertMinutes(minutes) {
      const hours = Math.floor(minutes / 60) // 计算小时
      const remainingMinutes = minutes % 60 // 计算剩余的分钟
      return `${hours > 10 ? hours : '0' + hours}:${remainingMinutes > 10 ? remainingMinutes : '0' + remainingMinutes}`
    },
    onImageError(event) {
      // 将事件的目标（即<img>元素）的src设置为本地占位图
      event.target.src = this.placeholderImage
      // 如果你想进一步处理错误，比如发送错误报告，可以在这里添加代码
      // ...
    },
    onClose() {
      const that = this
      that.visible = false
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 切换tabs
    callback(e) {
      this.active = e
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      const postIds = row.id || this.ids
      if (row.id) {
        ids = [{ id: postIds }]
      } else {
        postIds.forEach((v) => {
          ids.push({ id: v })
        })
      }
      this.$confirm({
        title: '是否确认冻结此用户?',
        onOk() {
          return frozenTenant(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('冻结成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'system/post/export',
            {
              ...that.queryParam,
            },
            `post_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
<style lang="less" scoped>
img {
  width: 80px;
  height: 80px;
}
.full-width-descriptions {
  width: 100% !important;
  // background: red;
  box-sizing: border-box; /* 确保包含内边距和边框 */
}
.ant-descriptions-item {
  width: 25%;
  // background: red;
}
.ant-descriptions-item-label {
  width: 100px;
  // background: red;
  text-align: left;
}
</style>
